"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    function generatePreviewRequest(revisionUuid) {
        return {
            type: _ActionTypes.GENERATE_PREVIEW_REQUEST,
            payload: revisionUuid
        };
    }
    function generatePreviewFailure(error, revisionUuid) {
        return {
            type: _ActionTypes.GENERATE_PREVIEW_FAILURE,
            payload: error,
            revisionUuid
        };
    }
    function generatePreviewSuccess(uuid, revisionUuid, status) {
        return {
            type: _ActionTypes.GENERATE_PREVIEW_SUCCESS,
            data: {
                uuid,
                revisionUuid,
                status
            }
        };
    }
    return {
        generatePreviewRequest,
        generatePreviewFailure,
        generatePreviewSuccess
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map